module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buttonText":"Read more"}}')
  delete Component.options._Ctor
}
